import React from 'react';
import '../template-css/Loader.scss';

const Loader = () => (
  <div className="page-loader">
    <div className="loader">Loading...</div>
  </div>
);

export default Loader;
